import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { User } from 'lucide-react';

interface UserAvatarProps {
  avatarUrl?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  showBorder?: boolean;
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
  avatarUrl,
  firstName,
  lastName,
  email,
  size = 'md',
  className = '',
  showBorder = false
}) => {
  // Gerar iniciais do nome
  const getInitials = () => {
    if (firstName && lastName) {
      return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
    }
    if (firstName) {
      return firstName.substring(0, 2).toUpperCase();
    }
    if (email) {
      return email.substring(0, 2).toUpperCase();
    }
    return 'U';
  };

  // Gerar cor de fundo baseada no nome/email
  const getBackgroundColor = () => {
    const name = `${firstName || ''}${lastName || ''}${email || ''}`;
    const colors = [
      'bg-primary',
      'bg-secondary',
      'bg-accent',
      'bg-slate-500',
      'bg-gray-500',
      'bg-zinc-500',
      'bg-neutral-500',
      'bg-stone-500'
    ];

    const charCodeSum = name.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);
    return colors[charCodeSum % colors.length];
  };

  // Definir tamanhos
  const sizeClasses = {
    sm: 'h-8 w-8 text-xs',
    md: 'h-10 w-10 text-sm',
    lg: 'h-12 w-12 text-base',
    xl: 'h-16 w-16 text-lg'
  };

  const borderClass = showBorder ? 'ring-2 ring-white ring-offset-2' : '';
  const bgColor = getBackgroundColor();

  return (
    <Avatar className={`${sizeClasses[size]} ${borderClass} ${className}`}>
      <AvatarImage src={avatarUrl || undefined} alt={`${firstName || ''} ${lastName || ''}`} />
      <AvatarFallback className={`${bgColor} text-white font-semibold`}>
        {avatarUrl === null ? (
          <User className="h-1/2 w-1/2" />
        ) : (
          getInitials()
        )}
      </AvatarFallback>
    </Avatar>
  );
};
